<div class="content-wrapper">
    <!-- Content Header (Page header) -->
    <section class="content-header">
        <h1>
            {{title}}
            <small>Control panel</small>
        </h1>
        <ol class="breadcrumb">
            <li>
                <a routerLink="">
                    <i class="fa fa-dashboard"></i> Home
                </a>
            </li>
            <li class="active">{{title}}</li>
        </ol>
    </section>
    <!-- Main content -->
    <section class="content document">
        <h2 class="text-center">
            Hướng dẫn sử dụng dành cho kỹ thuật viên
        </h2>
        <br>
        <ol>
            <li>
                <p>
                    Cài đặt máy in
                </p>
            </li>
        </ol>
        <ul>
            <li>
                <p>
                    Cài đặt driver của máy in vào máy dùng để in QRCode:
                    <a href="https://www.zebra.com/us/en/support-downloads/printers/industrial/zt410.html">
                        https://www.zebra.com/us/en/support-downloads/printers/industrial/zt410.html
                    </a>
                </p>
            </li>
            <li>
                <p>
                    Download và cài theo hình vẽ:
                </p>
            </li>
        </ul>
        <img class="doc-img" src="/assets/images/1.png">
        <p>
            - Cài đặt Zebra Setup Utilities xong, tiếp tục cài ZebraDesigner... Tất cả chọn mật định (chọn “Next”...).
            Chọn những tuỳ
            chọn giống hình bên dưới khi xuất hiện trong quá trình cài đặt.
        </p>
        <img class="doc-img" src="/assets/images/2.png">
        <img class="doc-img" src="/assets/images/3.png">
        <ol start="2">
            <li>
                <p>
                    Tạo QRCode, cân chỉnh QRCode, in QRCode
                </p>
            </li>
        </ol>
        <p>
            a. Tạo QRCode
        </p>
        <ul>
            <li>
                <p>
                    Login vào
                    <a target="_blank" href="https://www.smartsafe.ketsat.vn/">
                        https://www.smartsafe.ketsat.vn
                    </a>
                    (smartsafe@goodwill.vn, Goodwill@2017)
                </p>
            </li>
            <li>
                <p>
                    Chọn tab QR Code
                </p>
            </li>
            <li>
                <p>
                    Chọn “Create” trên góc trái màn hình.
                </p>
            </li>
            <li>
                <p>
                    Điền mã của mặt hàng, ví dụ GW-GUN-V1
                </p>
            </li>
            <li>
                <p>
                    Điền số lượng QRCode muốn tạo.
                </p>
            </li>
            <li>
                <p>
                    Số trang của 1 QRCode, tạm thời thông số này bằng 4.
                </p>
            </li>
        </ul>

        <p>
            b. Cân chỉnh QRCode
        </p>
        <ul>
            <li>
                <p>
                    Vào tab Layout Print trên thanh Menu.
                </p>
            </li>
            <li>
                <p>
                    Tạo mới hoặc sửa lại 1 mẫu nào đó.
                </p>
            </li>
            <li>
                <p>
                    Cân chỉnh trái, phải, dài rộng...
                </p>
            </li>
            <li>
                <p>
                    Lưu lại.
                </p>
            </li>
        </ul>
        <p>
            c. In QRCode
        </p>
        <ul>
            <li>
                <p>
                    Chọn QRCode muốn in và chọn “Print All” trên thanh Menu. Hoặc chọn vào biểu tượng in trên mỗi dòng
                    QRCode bên phải (gần nút
                    delete).
                </p>
            </li>
            <li>
                <p>
                    Chọn Layout đã tạo ở trên.
                </p>
            </li>
            <li>
                <p>
                    Chọn in như hình bên dưới:
                </p>
            </li>
        </ul>
        <img class="doc-img" src="/assets/images/4.png">
        <ol start="3">
            <li>
                <p>
                    Nạp code vào board
                </p>
            </li>
        </ol>
        <p>
            a. Lấy source code về máy:
        </p>
        <ul>
            <li>
                <p>
                    Vào link
                    <a target="_blank" href="https://git-scm.com/downloads">
                        https://git-scm.com/downloads
                    </a>
                    download và cài đặt Git theo hướng dẫn sau
                </p>
                <img class="doc-img" src="/assets/images/14.png">
            </li>
            <li>
                <p>
                    Chạy file vừa download về và chọ tất cả theo mật định. (Chỉ việc “Next” và “Finish”...)
                </p>
            </li>
            <li>
                <p>
                    Sau khi cài xong, vào Command Prompt như hình bên dưới:
                </p>
                <img class="doc-img" src="/assets/images/15.png">
            </li>
            <li>
                <p>
                    Trỏ đến thư mục cần chứa Source Code như hình (lệnh cd [đường dẫn đến thư mục]:
                </p>
                <img class="doc-img" src="/assets/images/16.jpg">
            </li>
            <li>
                <p>
                    Gõ lệnh để lấy Source Code về:<br />
                    git clone https://goodwillsafe@bitbucket.org/goodwillsafe/board.git
                </p>
                <img class="doc-img" src="/assets/images/17.jpg">
            </li>
            <li>
                <p>
                    Mật khẩu: Goodwill@2017 (Nếu không xuât hiện hộp thoại để nhập mật khẩu thì sẽ xuất hiện ngay trong
                    cửa sổ Command Prompt. Và nhập mật khẩu bình thường, sẽ không thấy mật khẩu in ra trên cửa sổ. Hãy
                    tự tin nhập xong mật khẩu và nhấn enter).
                </p>
                <p>
                    Source đã được lấy về. Chạy file esp8266Chipset.ino sau khi đã cài đặt Arduino như phần b bên dưới.
                </p>
                <img class="doc-img" src="/assets/images/18.jpg">
            </li>
        </ul>
        <p>
            b. Arduino
        </p>
        <ul>
            <li>
                <p>
                  -	Cài đặt Arduino có sẵn trong thư mục Board/Arduino1.6.9/arduino-1.6.9-windows.exe đã lấy về chung với source code.
                </p>
            </li>
            <li>
                <p>
                    Sau khi cài đặt Arduino, vào File -> reference, trong mục link, dán link sau vào: <a
                        href="http://arduino.esp8266.com/stable/package_esp8266com_index.json"
                        target="_blank">http://arduino.esp8266.com/stable/package_esp8266com_index.json</a><br />
                </p>
              <p>
              (Chú ý: kiểm tra link trên có hoạt động hay không bằng cách copy rồi dán vào web browser, nếu thấy load được dữ liệu => link còn hoạt động, nếu không thì phải tìm link khách thay thế bằng từ khoá báo lỗi khi nạp code)
                    Cài thêm thư viện cho nó. Như hình bên dưới:
                </p>
            </li>
        </ul>
        <img class="doc-img" src="/assets/images/5.png">
        <img class="doc-img" src="/assets/images/6.png">
        <img class="doc-img" src="/assets/images/7.png">
        <img class="doc-img" src="/assets/images/8.png">
        <img class="doc-img" src="/assets/images/9.png">
        <img class="doc-img" src="/assets/images/10.png">
        <ul>
            <li>
                <p>
                    Vào tool -> chọn như sau:
                </p>
            </li>
        </ul>
        <img class="doc-img" src="/assets/images/19.png">
        <img class="doc-img" src="/assets/images/11.png">
        <ul>
            <li>
                <p>
                    Lấy source code về để chạy: (phần a hướng dẫn ở trên).
                </p>
                <p>
                    Sau khi cấu hình thành công,
                </p>
                <p>
                    Source code sẽ xuất hiện khi mở file <b>esp8266chipset.ino</b>
                </p>
                <br>
                <img class="doc-img" src="/assets/images/20.png">
            </li>
        </ul>
        <p>
            c. Thay đổi code theo hướng dẫn của hình bên dưới:
        </p>
        <img class="doc-img" src="/assets/images/21.png">
        <img class="doc-img" src="/assets/images/12.png">
        <p>
            d.Nạp code
        </p>
        <ul>
            <li>
                <p>
                    Cắm board vào cab và bộ nạp. (nếu lần đầu sẽ tự động cài driver)
                </p>
            </li>
            <li>
                <p>
                    Cắm nguồn vào bộ nạp
                </p>
            </li>
            <li>
                <p>
                    Đảm bảo bộ nạp đã chuyển đổi qua chế độ nạp (bật tắt 1 nút trên bộ nạp)
                </p>
            </li>
            <li>
                <p>
                    Chọn cổng và port cho đúng. Kiểm tra lại driver của cổng nạp nếu không chọn được port. (Xem thông số
                    trên chip cổng nạp rồi tìm driver – cái hiện tại mình đang dùng là “Driver CP2102”)
                </p>
            </li>
            <li>
                <p>
                    Nhấn nút setting (nút màu đỏ) -> Chọn nút nạp như hình:
                </p>
            </li>
        </ul>
        <img class="doc-img" src="/assets/images/13.png">
        <p>
            - Đảm bảo code đã được nạp xong bằng cách xem kết quả trên Arduino.<br />
            - Test lại board bằng cách pair bởi ứng dụng trên điện thoại di động. (Nhớ rút cab nạp ra rồi mới test)
        </p>
        <p>
            e.	Nếu có lỗi phát sinh về Json, bạn phải xem lại version của Library Jason:
        </p>
        <p>
        <img class="doc-img" src="/assets/images/22.png">
        </p>
        <p>
            f. Sau khi nạp code
        </p>
        <p>
            Phải đính kèm với QRCode tương ứng, cho vào 1 túi nilon hay khay.
        </p>
        <ol start="4">
            <li>
                <p>
                    Note khi release mới một version (dànhh cho lập trình viên)
                </p>
            </li>
        </ol>
        <p>
            Phải tạo 1 version mới trong CMS/App Info:
        </p>
        <ul>
            <li>
                <p>
                    App id: luôn phải là: “vn.goodwill.smartsafe” .
                </p>
            </li>
            <li>
                <p>
                    App version: trùng khớp với version sẽ release.
                </p>
            </li>
            <li>
                <p>
                    Device type: trùng khớp với platform sẽ release. (ADR: android phone, IOS: iPhone)
                </p>
            </li>
            <li>
                <p>
                    Force Update: Hiện tại chưa handle nên giá trị này PHẢI luôn gán là “FASE”
                </p>
            </li>
        </ul>
        <ol start="5">
            <li>
                <p>
                    Admin
                </p>
            </li>
        </ol>

        <p>
            Có 2 phân quyền:
        </p>
        <p>
            - Admin Toàn Quyền
        </p>
        <p>
            - Manager: Chỉ được tạo QRCode, In và xem hướng dẫn sử dụng.
        </p>
        <ul>
            <li>
                <p>
                    Admin có thể thêm người dùng (Admin mới hay Manager)
                </p>
            </li>
            <li>
                <p>
                    Phân quyền cho người dùng (Admin hay Manager)
                </p>
            </li>
            <li>
                <p>
                    Xem một số thông tin của khách hàng.
                </p>
            </li>
        </ul>
    </section>
</div>



// WEBPACK FOOTER //
// /build/client-cms/src/app/dashboard/dashboard.component.html